import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { combineLatest, Subscription } from "rxjs";
import { GenBaseStoreService } from "../../../services/base-store.service";
import { TooltipPosition } from "../../../enums/tooltip-position.enum";
import { Product } from '@spartacus/core';

@Component({
    selector: 'gen-dealer-acquisition-product',
    templateUrl: './dealer-acquisition-product.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GenDealerAcquisitionProductComponent implements OnInit, OnDestroy {

  @Input() product: Product;

  tooltipMessage: string;
  callForPricingMessage = '';
  contactForPricingHref: string;
  TooltipPosition = TooltipPosition;
  private subscriptions = new Subscription();

  constructor(
    private cdr: ChangeDetectorRef,
    private baseStoreService: GenBaseStoreService,
  ) {
  }

  ngOnInit(): void {
    this.getTooltip();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private getTooltip() {
    this.subscriptions.add(
      combineLatest([
        this.baseStoreService.getTooltipMessage(),
        this.baseStoreService.getPhoneNumber(),
      ]).subscribe(([message, phoneOrEmail]) => {
        this.tooltipMessage = message?.message;

        if(phoneOrEmail?.contactInfo) {
          this.contactForPricingHref = phoneOrEmail?.contactInfo?.includes('@') ? `mailto: ${phoneOrEmail?.contactInfo}` : `tel: ${phoneOrEmail?.contactInfo}`;
        }
        this.cdr.markForCheck();
      })
    );
  }
}
